
import { defineComponent, ref, watch, onMounted } from "vue";
import { useRoute, RouterLink, useRouter } from "vue-router";
export default defineComponent({
  name: "Rolling",
  setup() {
    const routerList = ref();
    const route = useRoute();
    const router = useRouter();
    const currRoute = ref<{ name: any; path: string }[]>([
      {
        name: "Home",
        path: "/home",
      },
      {
        name: route.name,
        path: route.fullPath,
      },
    ]);
    watch(
      () => route.fullPath,
      () => {
        // console.log(route.fullPath, "888888888888888888888");
        // console.log(router.currentRoute.value.fullPath, "99999999");
        currRoute.value.push({ name: route.name, path: route.fullPath });
        removal(currRoute.value as any);
        // console.log(router.currentRoute.value.fullPath, "99999999999999999999999999999");
        // console.log(currRoute.value);
      }
    );
    onMounted(() => {
      routerList.value.scrollLeft = window.localStorage.getItem("pageTabsBar") ? window.localStorage.getItem("pageTabsBar") : 0;
      for (let i = 0; i < currRoute.value.length; i++) {
        for (let j = i + 1; j < currRoute.value.length; j++) {
          if (currRoute.value[i].name == currRoute.value[j].name) {
            currRoute.value.splice(j, 1);
          }
        }
      }
    });
    const offset = ref(70);
    const handleScrollLeft = () => {
      let offsetVal = routerList.value.scrollLeft - offset.value > 0 ? routerList.value.scrollLeft - offset.value : 0;
      let timer = setInterval(() => {
        routerList.value.scrollLeft -= 2;
        if (routerList.value.scrollLeft <= offsetVal) {
          window.localStorage.setItem("pageTabsBar", routerList.value.scrollLeft);
          clearInterval(timer);
        }
      }, 5);
    };
    const handleScrollRight = () => {
      let offsetVal = routerList.value.scrollLeft + offset.value;
      let maxVal = routerList.value.scrollWidth - routerList.value.clientWidth;
      let timer = setInterval(() => {
        routerList.value.scrollLeft += 2;
        if (routerList.value.scrollLeft >= offsetVal || routerList.value.scrollLeft >= maxVal) {
          window.localStorage.setItem("pageTabsBar", routerList.value.scrollLeft);
          clearInterval(timer);
        }
      }, 5);
    };
    const removal = (arr: any) => {
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i].name == arr[j].name) {
            arr.splice(j, 1);
          }
        }
      }
      return arr;
    };
    const delectRouter = (index: number, item: any) => {
      if (item.path != route.fullPath) {
        currRoute.value.splice(index, 1);
      } else {
        currRoute.value.splice(index, 1);
        if (currRoute.value.length == 0) {
          router.push("/home");
        } else {
          if (index == 0) {
            router.push(currRoute.value[index].path);
          } else {
            router.push(currRoute.value[index - 1].path);
          }
        }
      }
    };
    const routeDisplay = ref(false);
    const routerTab = () => {
      //
      if (!routeDisplay.value) {
        routeDisplay.value = true;
      } else {
        routeDisplay.value = false;
      }
    };
    // 关闭当前标签
    const currRouter = () => {
      // console.log(route.path);
      if (currRoute.value.length) {
        currRoute.value.forEach((item: any, index: number) => {
          if (item.path == route.path && item.path != "/home") {
            currRoute.value.splice(index, 1);
            if (currRoute.value.length == 0) {
              router.push("/home");
            } else {
              if (index == 0) {
                router.push(currRoute.value[index].path);
              } else {
                router.push(currRoute.value[index - 1].path);
              }
            }
          }
        });
      }

      console.log(currRoute.value);
    };
    // 关闭其他标签
    const otherRouter = () => {
      if (currRoute.value.length) {
        for (let i = 0; i < currRoute.value.length; i++) {
          if (currRoute.value[i].path != route.path && currRoute.value[i].path != "/home") {
            currRoute.value.splice(i, 1);
            --i;
          }
        }
      }
    };
    // 关闭全部要标签
    const AllRouter = () => {
      if (currRoute.value.length) {
        for (let i = 0; i < currRoute.value.length; i++) {
          if (currRoute.value[i].path != "/home") {
            currRoute.value.splice(i, 1);
            --i;
          }
        }
        router.push("/home");
      }
    };
    return {
      currRouter,
      otherRouter,
      AllRouter,
      currRoute,
      RouterLink,
      router,
      delectRouter,
      routerList,
      handleScrollLeft,
      handleScrollRight,
      routerTab,
      routeDisplay,
    };
  },
});
